import React, { useEffect, useState } from "react";

import { confirmEmailToken } from "@/api/auth";
import { useAuth } from "@/store/authStore";
import cls from "./styles.module.scss";

function getTokenFromUrl() {
  const url = new URL(window.location.href);
  return url.searchParams.get("token");
}

export function EmailConfirm() {
  const setTokens = useAuth((s) => s.setTokens);
  const [text, setText] = useState("Подтверждаем email...");

  useEffect(() => {
    const token = getTokenFromUrl();
    if (!token) {
      setText("Нет токена подтверждения в ссылке.");
      return;
    }

    confirmEmailToken(token)
      .then((tokens) => {
        setTokens(tokens.access, tokens.refresh, "email");
        window.location.href = "/";
      })
      .catch(() => {
        setText("Не удалось подтвердить email. Запросите письмо ещё раз.");
      });
  }, [setTokens]);

  return (
    <div className={cls.page}>
      <div className={cls.card}>
        <h1 className={cls.title}>БКоннект</h1>
        <p className={cls.subtitle}>{text}</p>
      </div>
    </div>
  );
}
